import PropTypes from 'prop-types'

const MenuNoOptionsMessage = ({ selectProps, handleAddOption }) => {
  const { inputValue } = selectProps

  const value = inputValue.length === 0 ? 'No options' : inputValue

  return (
    <div
      className="menu-no-options-message-wrapper"
      role="button"
      onClick={() => handleAddOption(inputValue)}
    >
      <div className="menu-no-options-message-wrapper__value">{value}</div>
      <div className="menu-no-options-message-wrapper__value-new-tag">(new tag)</div>
    </div>
  )
}

MenuNoOptionsMessage.propTypes = {
  selectProps: PropTypes.shape({
    inputValue: PropTypes.string.isRequired,
  }).isRequired,
  handleAddOption: PropTypes.func.isRequired,
}

export default MenuNoOptionsMessage
